import { call, put, takeLatest } from "redux-saga/effects";

import { API } from "../api/api";
import { SkeletonActionTypes } from "../actions/actionTypes";
import { skeletonStoreSelectors } from "../store";
import { ToasterService } from "../services/toaster/toaster.service";
import routes from "../jsons/routes.json"

function* initialize() {
    try {
        //const routesResponse = yield call(API.getRoutes);

        const subAppsConfig = skeletonStoreSelectors.subAppsConfig();

        yield put({
            type: SkeletonActionTypes.INITIALIZE_SUCCESS,
            payload: {
                routes: routes,
                subAppsConfig
            }
        });
    } catch (e) {
        if (e.toString().includes("Error: Network Error")) {
            ToasterService.errorToast(
                "Connection refused. Validate if internet access exists."
            );
            if (localStorage.getItem("sessionid")) {
                localStorage.removeItem("sessionid");
                window.location.reload();
            }
        } else {
            ToasterService.errorToast("Initialization error.");
            localStorage.removeItem("sessionid");
            if(window.location.pathname !== "/") {
                window.location.reload();
            }
        }
        API.handleError(e.response);

        yield put({
            type: SkeletonActionTypes.INITIALIZE_FAIL,
            message: e.message
        });
    }
}

export function* initializeWatcher() {
    yield takeLatest(SkeletonActionTypes.INITIALIZE, initialize);
}
